import video from './assets/media/map-loop_v12.mp4'

const screensaverConfig = {
    videoFile: video,
    idleDelay: 600000, //milliseconds
    loop: true,
    controls: false,
    muted: true,
    autoPlay: true,
    events: [
        'keydown',
        'mousedown',
        'touchstart',
        'touchmove',
        'MSPointerDown',
    ]
};

export default screensaverConfig;
